import React from 'react';
import logo from '../../assets/logo_thankfully_black_1x.png';
import './PlaceHolderPage.css';
import { Link } from 'react-router-dom';

const PlaceHolderPage = () => {
    return (
        <div className="placeholder-container">
            <div className="logo-coming-soon">
                <Link className="footer-text" to={{ pathname: '/', state: { contact: false, intro: true} }}>
                    <img className="placeholder-image" src={logo}/>
                </Link> 
                <h1 className="placeholder-text" >coming soon</h1>
            </div>
            
            <div className="footer">
                <div className="footer-top">
                        <a className="footer-text" href="mailto:team@thankfully.com?subject=Thankfully, Some Feedback">Feedback</a>
                        <Link className="footer-text" to="/contact">Contact Us</Link>
                        <Link className="footer-text" to="/terms">Terms of Use</Link>
                    </div>
                    <div className="footer-bottom">
                    <div className="footer-text" >© 2018 Thankfully Inc.</div>
                </div>
            </div>
        </div>
    )
}

export default PlaceHolderPage;


// WEBPACK FOOTER //
// ./src/components/PlaceHolderPage/PlaceHolderPage.js